import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import { Title, useTranslate } from "react-admin"
import sample from "images/sample.jpeg"

export default function Dashboard() {
    const translate = useTranslate()

    return (
        <Card>
            <Title title={translate("main")} />
            <CardContent>
                <h1>{translate("welcome")}</h1>
                <h2>
                    <a target="_blank" href="https://docs.google.com/document/d/1xvIWjof7aZ9cm2k35PBPde8HRNeV8n-6tpvEOEeD2l0/">
                        {translate("instruction")}
                    </a>
                </h2>
                <h2>Как создать шаблон</h2>
                <p>
                    Для того чтоб заполнить шаблон используются выражения для разметки. Они бывают двух типов:
                </p>
                <ol>
                    <li>Постоянные
                        <ul>
                            <li>Типы</li>
                        </ul>
                    </li>
                    <li>Пользовательские
                        <ul>
                            <li>Типы</li>
                        </ul>
                    </li>
                    <li>Форматирование</li>
                    <li>Пример</li>
                </ol>
                <h2>Постоянные выражения</h2>
                <p>Постоянные выражения могут быть использованы в любом документе т.к это поля которые присутствуют в каждой справке. Далее будут перечислены возможные постоянные выражения:
                </p>
                <ol>
                    <li><b>identity_string</b> - номер студента</li>
                    <li><b>first_name - имя</b></li>
                    <li><b>last_name</b> - фамилия</li>
                    <li><b>id</b> - номер справки</li>
                </ol>
                <p>Постоянные выражения всегда должны начинаться с "&#123;" и заканчиваться "&#125;". Пример: <b>&#123;identity_string&#125;</b></p>
                <h2>Пользовательские выражения</h2>
                <p>Они состоят из 2-х частей, разделенных следующим знаком “|” и выглядят так: <b>&#123;Пример выражения|string&#125;</b></p>
                <p>Каждое такое выражение должно начинаться с "&#123;" и заканчиваться "&#125;". <b>Первая часть</b> такого выражения это, то как будет называться поле для ввода. На сайте для студентов данное в примере выражение будет выглядеть так:</p>
                <img width="50%" src={sample} alt="sample of expression" />
                <p><b>Вторая часть</b> выражения это тип для данного поля. Существуют следующие типы:</p>
                <ol>
                    <li><b>string</b> - для для текстового ввода</li>
                    <li><b>text</b> - для текстового ввода большого объема текста</li>
                    <li><b>date</b> - для ввода дат</li>
                    <li><b>int</b> - для цифр</li>
                </ol>
                <p>Можно использовать только типы что указаны выше, не зарегистрированные типы вызовут ошибку при попытке загрузить данный шаблон.</p>
                <h2>Форматирование текста</h2>
                <p>Форматирование сохраняет все шрифты и форматирование текста. Чтобы сделать поле в конечном документе после заполнения студентом жирным достаточно просто пометить его как жирное.</p>
                Пример с постоянным подчеркнутым полем: <u>&#123;Пример выражения|string&#125;</u> <br/>
                Пример с постоянным жирным полем: <b>&#123;identity_string&#125;</b>
                <h2>
                    <a target="_blank" href="https://docs.google.com/document/d/1daSWUSbsG2e03t9kHouSEUd7NaI70ajrpa-NQ8aSKkY/edit">
                        Пример
                    </a>
                </h2>
            </CardContent>
        </Card>
    )
}
